/** Textos padrão do DialogFooter. */
export const DIALOG_CANCEL_LABEL = "Cancelar";
export const DIALOG_CONFIRM_LABEL = "Confirmar";
